/** Local-calendar helpers. Dates are plain 'YYYY-MM-DD' strings throughout the app. */
import { locale } from './i18n';

export function isoDate(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function today(): string {
  return isoDate(new Date());
}

export function addDays(date: string, n: number): string {
  const d = new Date(date + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return isoDate(d);
}

export function diffDays(a: string, b: string): number {
  return Math.round((new Date(a + 'T12:00:00').getTime() - new Date(b + 'T12:00:00').getTime()) / 864e5);
}

export function dow(date: string): number {
  return new Date(date + 'T12:00:00').getDay();
}

export function nextSunday(from: string = today()): string {
  const d = dow(from);
  return d === 0 ? from : addDays(from, 7 - d);
}

export function weekStart(date: string): string {
  return addDays(date, -dow(date));
}

export function prettyDate(date: string, opts: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'long' }): string {
  return new Date(date + 'T12:00:00').toLocaleDateString(locale(), opts);
}

export function nowMinutes(): number {
  const n = new Date();
  return n.getHours() * 60 + n.getMinutes();
}

export function toMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
}

export function endTime(hhmm: string, dur: number): string {
  const t = toMinutes(hhmm) + dur;
  return `${String(Math.floor(t / 60) % 24).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
}
